import httpService from '../services/http-service';
import {
  smartFetch,
  cancelRequestById,
  cancelRequestsByPattern,
  cancelAllRequests,
  clearCache as clearSmartFetchCache,
} from './smartFetch';

const resolveBaseUrl = (baseURL, fullUrl, useRapid = false) => {
  if (fullUrl) return '';
  if (typeof baseURL === 'string') return baseURL;
  return useRapid
    ? globalThis?.config?.RAPID_URL ?? ''
    : globalThis?.config?.API_URL ?? '';
};

const normalizeOptions = (options = {}, useRapid = false) => {
  const {
    headers = {},
    baseURL,
    axiosConfig = {},
    fullUrl = false,
    useCache = false,
    cacheTTL,
    cacheKey,
    requestId,
    ...rest
  } = options;

  return {
    headers: {
      ...httpService.getHeaders(),
      ...headers,
    },
    baseURL: resolveBaseUrl(baseURL, fullUrl, useRapid),
    axiosConfig,
    fullUrl,
    useCache,
    cacheTTL,
    cacheKey,
    requestId,
    ...rest,
  };
};

const smartHttp = {
  get(url, params = {}, options = {}) {
    const normalized = normalizeOptions({ useCache: true, ...options });
    return smartFetch({
      url,
      method: 'get',
      params,
      ...normalized,
    });
  },

  post(url, data = {}, params = {}, options = {}) {
    const normalized = normalizeOptions(options);
    return smartFetch({
      url,
      method: 'post',
      data,
      params,
      ...normalized,
    });
  },

  update(url, data = {}, params = {}, options = {}) {
    const normalized = normalizeOptions(options);
    return smartFetch({
      url,
      method: 'put',
      data,
      params,
      ...normalized,
    });
  },

  delete(url, data = {}, options = {}) {
    const normalized = normalizeOptions(options);
    return smartFetch({
      url,
      method: 'delete',
      data,
      ...normalized,
    });
  },

  getRapid(url, params = {}, options = {}) {
    const normalized = normalizeOptions({ useCache: true, ...options }, true);
    return smartFetch({
      url,
      method: 'get',
      params,
      ...normalized,
    });
  },

  postRapid(url, data = {}, params = {}, options = {}) {
    const normalized = normalizeOptions(options, true);
    return smartFetch({
      url,
      method: 'post',
      data,
      params,
      ...normalized,
    });
  },

  putRapid(url, data = {}, params = {}, options = {}) {
    const normalized = normalizeOptions(options, true);
    return smartFetch({
      url,
      method: 'put',
      data,
      params,
      ...normalized,
    });
  },
  cancelRequest: cancelRequestById,
  cancelMatchingRequests: cancelRequestsByPattern,
  cancelAllRequests,
  clearCache: clearSmartFetchCache,
};

smartHttp.put = smartHttp.update;

export default smartHttp;
export {
  smartFetch,
  cancelRequestById,
  cancelRequestsByPattern,
  cancelAllRequests,
  clearSmartFetchCache as clearCache,
};
